import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgMapMarkerIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="map_marker_svg__nc-icon-wrapper">
      <path d="m61.713 5.042-19.666 5.9-19.676-7.871a1.01 1.01 0 0 0-.658-.029l-20 6A1 1 0 0 0 1 10v48a1 1 0 0 0 1.287.958l19.666-5.9 16.676 6.67a1 1 0 0 0 .742-1.858L23 51.323V5.477l18 7.2V25a1 1 0 0 0 2 0V12.744l18-5.4V28a1 1 0 0 0 2 0V6a1 1 0 0 0-1.287-.958ZM21 51.256l-18 5.4V10.744l18-5.4Z" />
      <path
        d="M50 30c-6.391 0-13 4.746-13 12.688 0 7.565 11.818 18.581 12.321 19.046a1 1 0 0 0 1.358 0C51.182 61.269 63 50.253 63 42.688 63 34.746 56.391 30 50 30Zm0 17a4 4 0 1 1 4-4 4 4 0 0 1-4 4Z"
        data-color="color-2"
      />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgMapMarkerStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgMapMarkerIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const MapMarkerIcon: any = SvgMapMarkerStyle;
export default MapMarkerIcon;
